import { CityDialogComponent } from './components/city-dialog/city-dialog.component';
import { TranslateHelper } from './../../_helpers/translate-helper';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { SectorPageService } from './../../_services/sectorPage.service';
import { ChangeDetectorRef, Component, Inject, Input, NgZone, OnDestroy, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router, UrlSerializer, RouterLink } from '@angular/router';
import { AuthenticationService, CartService, QuotationCartService, UserService } from '@app/_services';
import { HeaderService } from '@app/_services/header.service';
import { OffcanvasCartService } from '@app/_services/offcanvas-cart.service';
import { RootService } from '@app/_services/root.service';
import { SharedService } from '@app/_services/shared.service';
import { WishlistService } from '@app/_services/wishlist.service';
import { StoreService } from '@services/store.service';
import { DropcartType, DropcartComponent } from './components/dropcart/dropcart.component';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NavigationLink } from '@app/_interfaces/navigation-link';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, takeUntil } from 'rxjs/operators';
import { DirectionService } from '@app/_services/direction.service';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { DropdownDirective } from '@app/shared/directives/dropdown.directive';
import { SiteService } from '@app/_services/site.service';
import { CategoriesHeader } from '../../_components/categories-header/categories-header.component';
import { TopbarComponent } from '../../_components/topbar/topbar.component';
import { AccountMenuComponent } from './components/account-menu/account-menu.component';
import { IndicatorComponent } from './components/indicator/indicator.component';
import { LinksComponent } from './components/links/links.component';
import { SearchComponent } from '../../shared/components/search/search.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { DropdownDirective as DropdownDirective_1 } from '../../shared/directives/dropdown.directive';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, RouterLink, DropdownDirective_1, MatIconModule, MatTooltipModule, IconComponent, MatProgressSpinnerModule, NgFor, SearchComponent, LinksComponent, IndicatorComponent, DropcartComponent, AccountMenuComponent, TopbarComponent, CategoriesHeader, AsyncPipe, TranslateModule]
})

@UntilDestroy()
export class HeaderComponent implements OnDestroy, OnInit {
    @Input() layout: 'classic' | 'compact' = 'classic';
    dropcartType: DropcartType;

    constructor(@Inject(PLATFORM_ID) private platformId: any,
        private route: ActivatedRoute,
        private offcanvasCart: OffcanvasCartService,
        public root: RootService,
        public cart: CartService,
        public quotationCart: QuotationCartService,
        public zone: NgZone,
        public header: HeaderService,
        public translateService: TranslateService,
        private router: Router,
        private direction: DirectionService,
        private urlSerializer: UrlSerializer,
        private userService: UserService,
        private authService: AuthenticationService,
        private cd: ChangeDetectorRef,
        private sharedService: SharedService,
        public translateHelper: TranslateHelper,
        public modalService: BsModalService,
        private dialog: MatDialog,
        public siteService: SiteService

    ) { }

    destroy$: Subject<void> = new Subject<void>();

    currentCountry;
    selectedZone;
    countries = [];
    bsModalRef: BsModalRef;
    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;

    currentUser;

    ngOnInit(): void {
        this.route.data.pipe(takeUntil(this.destroy$)).subscribe(data => {
            this.dropcartType = data.dropcartType || 'dropdown';
        });

        this.authService.currentUser.pipe().subscribe((user: any): any => {
            this.currentUser = user;
        });

        this.authService.currentZone.subscribe(zone => {
            if (!this.countries || this.countries.length == 0)
                this.authService.getCountries().subscribe((response) => {
                    if (response?.code == 200) {
                        this.countries = response.data;
                        this.getUserCountry(zone);
                    }
                });
            else
                this.getUserCountry(zone);

        })
    }

    getUserCountry(zone) {
        this.selectedZone = zone;
        let countryId = zone?.country?._id || this.countries[0]?._id
        let userCountry = this.countries.find((country) => country._id == countryId);
        this.currentCountry = userCountry
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onCartClick(): void {
        if (this.dropcartType === 'offcanvas') {
            this.offcanvasCart.open();
        }
    }

    changeLangage(lang: string) {
        this.authService.currentUser.subscribe((user: any): any => {
            if (user?.preferances?.language != lang)
                this.userService.setLanguage({ lang: lang }).subscribe((res) => {
                    if (res.code == 200) {

                        this.translateService.use(lang);

                        let navigationExtras: NavigationExtras;
                
                        const tree = this.router.parseUrl(this.router.url);
                
                        let url: any = this.urlSerializer.parse(this.router.url);
                
                        let stateUrl = this.router.url.split('/');
                        let commands = [];
                
                        stateUrl.forEach((segment) => {
                            if (segment == "" || segment == "en" || segment == "ar") return;
                
                            if (segment.includes('?')) {
                                commands.push(segment.split('?')[0]);
                                if (!_.isEmpty(url.queryParams) || !_.isEmpty(tree.queryParams)) {
                                    //commands.push({queryParams: url.queryParams??tree.queryParams});
                                    navigationExtras = {
                                        queryParams: url.queryParams ?? tree.queryParams
                                    };
                                }
                
                            } else {
                                commands.push(segment);
                            }
                
                        });
                
                        commands.unshift('/'.concat(lang))
                
                        this.router.navigate(commands, navigationExtras);
                
                        lang == 'ar' ? this.direction.value = 'rtl' : 'ltr';
                    } else {
                        //console.log("Error setting user prefered language");
                    }

                }, (error) => {
                    //console.log("Error setting user prefered language");
                });
        });


    }

    changeCountry(country, languageDropdown) {
        languageDropdown?.toggle(false)
        this.citiesModal(country);
    }

    citiesModal(country): void {
        this.dialog.open(CityDialogComponent, {
            data: { country: country }
        }).afterClosed().subscribe(response => {
            if (response) {
                this.authService.setUserZone(response);
                this.selectedZone = response;
            }
        }, (error) => {
        });
    }


    cityChanged(event) {

    }

    loadCountries(languageDropdown: DropdownDirective) {
        if (!this.countries || this.countries.length == 0)
            this.authService.getCountries().subscribe((response) => {
                if (response?.code == 200) {
                    this.countries = response.data;
                }
            });
        languageDropdown.toggle();
    }

}
